import { Directive, TemplateRef } from "@angular/core";

@Directive({ selector: "[radrQuerySwitchGroup]" })
export class QuerySwitchGroupDirective {
  constructor(public template: TemplateRef<any>) {}
}
